// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l7eo","delete":"styles_delete__1iA-k","update":"styles_update__2xSiY","add":"styles_add__38bnL"};